import axiosInstance from '@/core/api'
import {
	PlayerTagResponse,
	TagStatisticsResponse,
	GetPlayersByTagResponse,
	CreatePlayerTagDto,
	UpdatePlayerTagDto,
	AssignTagsToPlayersDto,
	RemoveTagsFromPlayersDto,
	GetPlayerTagsRequest,
	GetPlayersByTagsRequest,
} from '../../types'

// Get all player tags
export const getPlayerTags = async (
	params?: GetPlayerTagsRequest,
): Promise<PlayerTagResponse[]> => {
	const response = await axiosInstance.get<PlayerTagResponse[]>(
		'/admin/player-tags',
		{ params },
	)
	return response.data
}

// Get player tag by ID
export const getPlayerTagById = async (
	id: string,
): Promise<PlayerTagResponse> => {
	const response = await axiosInstance.get<PlayerTagResponse>(
		`/admin/player-tags/${id}`,
	)
	return response.data
}

// Get player tag statistics
export const getPlayerTagStatistics =
	async (): Promise<TagStatisticsResponse> => {
		const response = await axiosInstance.get<TagStatisticsResponse>(
			'/admin/player-tags/statistics',
		)
		return response.data
	}

// Get players filtered by tags
export const getPlayersByTags = async (
	params?: GetPlayersByTagsRequest,
): Promise<GetPlayersByTagResponse> => {
	const response = await axiosInstance.get<GetPlayersByTagResponse>(
		'/admin/player-tags/players',
		{ params },
	)
	return response.data
}

// Create a new player tag
export const createPlayerTag = async (
	payload: CreatePlayerTagDto,
): Promise<PlayerTagResponse> => {
	const response = await axiosInstance.post<PlayerTagResponse>(
		'/admin/player-tags',
		payload,
	)
	return response.data
}

// Update a player tag
export const updatePlayerTag = async (
	id: string,
	payload: UpdatePlayerTagDto,
): Promise<PlayerTagResponse> => {
	const response = await axiosInstance.patch<PlayerTagResponse>(
		`/admin/player-tags/${id}`,
		payload,
	)
	return response.data
}

// Delete a player tag
export const deletePlayerTag = async (id: string): Promise<void> => {
	await axiosInstance.delete(`/admin/player-tags/${id}`)
}

// Assign tags to players
export const assignTagsToPlayers = async (
	payload: AssignTagsToPlayersDto,
): Promise<void> => {
	await axiosInstance.post('/admin/player-tags/assign', payload)
}

// Remove tags from players
export const removeTagsFromPlayers = async (
	payload: RemoveTagsFromPlayersDto,
): Promise<void> => {
	await axiosInstance.post('/admin/player-tags/remove', payload)
}
